/** Local mirror of the backend `crochetSizingDefaults` user setting, so
 *  diagram creation can read it synchronously (no await at the New-diagram
 *  click). Server is the source of truth for signed-in users: the mirror is
 *  refreshed on gallery mount (use-sync-crochet-sizing-defaults) and written
 *  through on settings Apply. Try-mode/anonymous users never write it and get
 *  factory defaults. Mirrors the direct localStorage pattern of
 *  font-size-preference.ts — no global settings context exists. */
import {
    sanitizeCrochetSizingDefaults, type CrochetSizingDefaults,
} from '@/crochet-editor/sizing-defaults';

const STORAGE_KEY = 'stitchpress-crochet-sizing-defaults';

type Listener = (dd: CrochetSizingDefaults) => void;
const listeners = new Set<Listener>();

export function getCrochetSizingDefaults(): CrochetSizingDefaults {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (raw == null) return {};
        return sanitizeCrochetSizingDefaults(JSON.parse(raw));
    } catch {
        return {};
    }
}

export function setCrochetSizingDefaults(dd: CrochetSizingDefaults): void {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(dd));
    } catch {
        // Ignore storage failures (private mode, etc.).
    }
    for (const l of listeners) l(dd);
}

export function onCrochetSizingDefaultsChange(listener: Listener): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
}
